import { components } from "src/strapi/schema";
import { Button } from "src/components/ui/button";
import { cn } from "src/lib/utils";
import { useState } from "react";
import { NavbarDropdownNavItem } from "src/components/navbar/dropdown-item";
import { Logo } from "src/components/ui/logo/logo";
import { MenuIcon } from "src/components/ui/icons/menuIcon";
import { Link } from "@tanstack/react-router";
import { InquiryModal } from "./inquiry-modal";

export const Navbar = ({
  navbarItems,
}: {
  navbarItems: components["schemas"]["Navbar"]["nav_items"];
}) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  return (
    <>
      <div
        className={cn(
          "h-navbar-height border-border/10 bg-background/50 sticky top-0 z-50 w-full border-b backdrop-blur-md transition-all duration-500",
        )}
      >
        <nav
          className={cn(
            "text-foreground container mx-auto flex h-full w-full flex-wrap items-center justify-between px-4",
            {
              "text-background": isMobileMenuOpen,
            },
          )}
        >
          <Link to={"/"} aria-label={"Vesas"}>
            <Logo className={"m-4 w-28 md:w-32 lg:w-40"} />
          </Link>

          <MenuIcon
            isOpen={isMobileMenuOpen}
            className={"relative z-20 cursor-pointer xl:hidden"}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          />

          <div
            className={cn(
              "w-full xl:flex xl:w-auto xl:items-center",
              {
                hidden: !isMobileMenuOpen,
              },
              {
                "no-doc-scroll bg-foreground/95 pt-navbar-height absolute top-0 left-0 h-dvh w-svw":
                  isMobileMenuOpen,
              },
            )}
          >
            <ul
              className={
                "divide-border/20 flex w-full flex-col items-start divide-y xl:flex-row xl:gap-4 xl:divide-none"
              }
            >
              {navbarItems?.map((item) => {
                switch (item.__component) {
                  case "ui.button":
                    return (
                      <li
                        key={item.text}
                        className={
                          "flex w-full items-center py-2 md:pl-4 xl:py-0"
                        }
                      >
                        <Button
                          asChild
                          variant={item.variant}
                          size={item.size}
                          className={cn(
                            "w-full justify-start text-lg font-semibold tracking-wide uppercase",
                          )}
                          onClick={closeMobileMenu}
                        >
                          <Link to={item.link ?? ""}>{item.text}</Link>
                        </Button>
                      </li>
                    );
                  case "ui.dropdown":
                    return (
                      <li
                        key={item.id}
                        className={"w-full py-2 md:pl-4 xl:py-0"}
                      >
                        <NavbarDropdownNavItem
                          dropdown={item}
                          onNavigate={closeMobileMenu}
                        />
                      </li>
                    );
                }
              })}

              {/* Rychlá poptávka */}
              <InquiryModal />
            </ul>
          </div>
        </nav>
      </div>
    </>
  );
};
